import { defineMessages } from "react-intl";
import { FeatureAccessStatus } from "../../contract/pam.js";
const localizedFeatureAccessStatus = defineMessages({
  [FeatureAccessStatus.Unlocked]: {
    id: "featureAccessStatusUnlocked",
    defaultMessage: "Unlocked"
  },
  [FeatureAccessStatus.Locked]: {
    id: "featureAccessStatusLocked",
    defaultMessage: "Locked"
  }
});
export {
  localizedFeatureAccessStatus
};
//# sourceMappingURL=featureAccessStatus.js.map
